const Colors = {
  // BASE
  white: '#FFF',
  black: '#000',
  bordersGray: '#DAE9F2',
  fieldBorders: '#DAE9F2',
  translucentBlack: 'rgba(0,0,0,0.87)',
  gray: 'rgba(0,0,0,0.52)',
  lightGray: 'rgba(0,0,0,0.12)',
  error: '#f44336',
  translucentGreen: 'rgba(83,230,157,0.15)',
  green: 'rgb(102,189,88)',
  red: '#F55E64',
  lightBlue: '#1a5eaa',
  darkGray: '#D2D2D2',
  blue: '#0a5394',
  primary: '#1a5eaa',
  info: '#53E69D',
  transparent: 'transparent',

  // Badge
  badgeBase: '#F55E64',
  badgeIcon: '#FFF',

  // Signup
  signupBackground: 'rgb(245,245,245)',

  // Buttons
  primaryButton: '#33BDC0',
  primaryButtonHover: '#2FACAF',
  primaryTextButtonHover: '#7DD5D6',
  secondaryButton: '#19497D',
  secondaryButtonHover: '#174372',
  secondaryTextButtonHover: '#577AA0',
  alternativeButton: 'rgb(51,189,192)',
  disabledButton: '#E0E0E0',
  publicDashboardButton: 'rgb(51,189,192)',

  // Dashboard
  accountBalance: 'rgb(240,112,63)',
  toggleBase: 'rgb(51,189,192)',
  bulletsBase: 'rgb(240,112,63)',
  bulletsBorderBase: 'rgba(240,112,63,0.4)',
  tagBase: '#19497D',
  checkedBackground: 'rgb(51,189,192)',
  checkedOk: '#FFF',

  // Background
  errorScreenBackgroundColor: '#F7F7F9',

  // Complaints
  contactItemColor: 'rgb(240,112,63)',
  translucentLightBlue: 'rgba(64,196,254,0.2)',

  // Topbar
  topbarColor: 'rgb(28,74,123)',

  // SIDEBAR
  sidebarColor: 'rgb(22,62,99)',
  activeSidebarColor: 'rgb(34,88,139)',
  inactiveSidebarColor: 'rgb(22,62,99)',
  activeText: 'white',
  inactiveText: '#B3BCD3',
  translucentBlue: 'rgba(22,94,140,0.12)',
  suboptionActiveText: 'rgb(51,189,192)',

  // POINTS
  secondary: 'rgb(22,94,140)',
  accumulatedPoints: 'rgb(232,74,75)',

  // CONFIGURATION
  passwordContainerInactive: '#F7F7F9',
  iconColors: 'rgb(22,62,99)',

  // ACCOUNT DETAIL
  accountDetailBackgroundColor: '#ECF4FA',
  accountTableUnderline: '#DAE9F2',

  // UTTABLE
  oddRowColor: '#F7F7F9',
  evenRowColor: 'white',
  rowText: 'black',
  tableBorderColor: '#DAE9F2',
  shadowGrayTable: 'rgba(0,0,0,0.24)',
  tableHeaderBackground: '#F27036',
  tableHeaderText: '#FFF',

  // VOUCHERS
  lightblueVoucher: '#40C4FE',
  yellowVoucher: '#FFD200',
  greenVoucher: '#53E69D',
  redVoucher: '#F55E64',
  translucentRedVoucher: 'rgba(245,94,100,0.12)',
  vouchersBackground: 'rgb(236,244,250)',

  activeRowColor: '#ECF4FA',

  // UTMODAL
  modalOverlayColor: 'rgba(0, 0, 0, 0.75)',

  // UTCARD
  cardFlat: '#F7F7F9',

  // FORM RESPONSE DETAIL
  fieldDetailSeparatorColor: '#DAE9F2',

  // SIGNUP
  progressCompleted: '#FFD200',
  progressCompletedBorder: '#FFEFA8',
  progressUncompleted: '#DAE9F2',
  authAvatarBackground: '#FFF',

  // NOTIFICATIONS
  unreadNotification: '#ECF4FA',
  translucentGray: 'rgba(0,0,0,0.24)',

  // Consumption History colors
  historyFirstColorDark: '#69D8D4',
  historyFirstColorNormal: '#91E2DF',
  historyFirstColorSoft: '#C8F0EF',
  historyFirstColorStroke: '#56B1AE',
  historySecondColorDark: '#27A09F',
  historySecondColorNormal: '#61B9B9',
  historySecondColorSoft: '#B0DCDC',
  historySecondColorStroke: '#33BDC0',
  historyThirdColorDark: '#DC6632',
  historyThirdColorNormal: '#F37D48',
  historyThirdColorSoft: '#F5976C',
  historyThirdColorStroke: '#B15228',
  tooltipColor: 'rgba(41,41,41,0.87)',

  // Energy advisor
  squaredButton1: 'rgb(103,206,166)',
  squaredButton2: 'rgb(103,206,166)',
  squaredButton3: 'rgb(103,206,166)',
  squaredButton4: 'rgb(103,206,166)',
  squaredButton5: 'rgb(103,206,166)',
  squaredButton6: 'rgb(103,206,166)',
  categoriesTitle: 'rgb(103,206,166)',

  // Settings
  userInfoOddRow: 'rgb(218,233,237)',
  userInfoEvenRow: '#FFF',

  // Social Rate View
  socialRateLightBlue: '#86bbe6',
  socialRateBlue: '#3689c9',
  socialRateDarkBlue: '#104d81',

  notificationSuccess: '#388AC8',
  notificationError: '#F49773',
  notificationInfo: '#388AC8',

  // Bills
  billIconColor: '#00b1f1',

  attachmentBorder: '#1A5EAA',
  attachmentIcon: '#1A5EAA'
};

export default Colors;
